import WINDOW from "../../../utils/window";
import setDefaultParameters from "./set-default-parameters";

/**
 * @param {TriggerProps} trigger
 * @param {Map<String, any>} map
 * @returns {Map<String, any>}
 */
const getDefaultCoordinateParameters = (trigger, map) => {
  const axis = trigger.get("scroll") ? "y" : "both";

  const defaults = new Map([
    ["threshold", [null, null]],
    ["end", [null, null]],
    ["start", [null, null]],
    ["start_-_x", [0, "%"]],
    ["start_-_y", [0, "%"]],
    ["end_-_x", [100, "%"]],
    ["end_-_y", [100, "%"]],
    ["axis", [axis, null]],
    ["method", ["default", null]],
    ["keep", [false, null]],
  ]);

  return setDefaultParameters(defaults, map);
};

export default getDefaultCoordinateParameters;
